import { Link } from "react-router-dom";
import { ShieldCheck, Trash2, Database, Clock3, Mail, ArrowLeft } from "lucide-react";

const rows = [
  ["Kişisel hesap verileri (ad, e-posta, şifre)", "Uygulama içi silme ile anında; talep formu ile yapılan başvurularda e-posta doğrulaması tamamlandıktan sonra kalıcı olarak silinir"],
  ["Araç geçmişi kayıtları (hasar, kaza, ekspertiz, bakım, kaporta/boya, kilometre, muayene, servis ve belgeler)", "Silinmez; kişisel bilgilerden arındırılmış (anonim) olarak, araç geçmişi bütünlüğü için kalıcı olarak saklanır"],
  ["Teklif talepleri", "Kişisel alanları temizlenmiş (anonim) olarak saklanır"],
  ["Yasal zorunluluk gerektiren kayıtlar", "Yalnızca ilgili mevzuatın öngördüğü durumlarda, anonimleştirilerek saklanabilir"],
];

export default function HesapSilme() {
  return (
    <div data-testid="hesap-silme-page" className="min-h-screen bg-slate-100 text-slate-800">
      <div className="bg-[#0B1B33] px-5 py-6">
        <div className="max-w-2xl mx-auto flex items-center gap-3">
          <ShieldCheck className="w-7 h-7 text-[#F97316]" />
          <h1 className="text-white text-xl sm:text-2xl font-bold">OTO<span className="text-[#F97316]">KÜNYE</span> Hesap Silme</h1>
        </div>
      </div>

      <div className="max-w-2xl mx-auto px-5 py-10">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-[#F97316] transition-colors mb-6">
          <ArrowLeft className="w-4 h-4" /> Ana Sayfa
        </Link>

        <div className="bg-white border border-slate-200 rounded-2xl p-6 sm:p-8 space-y-8">
          <p className="text-sm leading-relaxed">
            Bu sayfa, Otokünye hesabınızı ve hesabınızla ilişkili kişisel verilerinizi nasıl kalıcı olarak
            silebileceğinizi açıklar. Bu sayfayı görüntülemek için üye girişi yapmanız gerekmez.
          </p>

          <section>
            <h2 className="flex items-center gap-2 text-[#0B1B33] font-bold text-base border-l-4 border-[#F97316] pl-3">
              <Trash2 className="w-4 h-4 text-[#F97316]" /> Uygulama İçinden Hesabınızı Kendiniz Silin (Önerilen — Anında İşlenir)
            </h2>
            <ol className="mt-3 list-decimal pl-6 space-y-1.5 text-sm leading-relaxed">
              <li>Otokünye web sitesinde veya mobil uygulamasında (Android / iOS) hesabınıza giriş yapın.</li>
              <li>Web'de <strong>üst menüdeki "Hesabımı Sil"</strong> seçeneğine; mobil uygulamada <strong>Hesap ekranındaki "Hesabımı Sil"</strong> butonuna dokunun.</li>
              <li>Karşınıza çıkan kalıcı silme uyarısını onaylayın.</li>
            </ol>
            <p className="mt-3 text-sm">Bu yöntemle silme işlemi <strong>anında ve kalıcı olarak</strong> gerçekleşir; geri alınamaz.</p>
          </section>

          <section>
            <h2 className="flex items-center gap-2 text-[#0B1B33] font-bold text-base border-l-4 border-[#F97316] pl-3">
              <Trash2 className="w-4 h-4 text-[#F97316]" /> Silinen Kişisel Veriler
            </h2>
            <ul className="mt-3 list-disc pl-6 space-y-1.5 text-sm leading-relaxed">
              <li>Hesap bilgileriniz (ad, e-posta adresi, şifre kaydı),</li>
              <li>Giriş/oturum ve şifre sıfırlama kayıtlarınız,</li>
              <li>Uygulama içi bildirimleriniz,</li>
              <li>İşletme hesabıysa işletme/servis/çekici profil kayıtlarınız,</li>
              <li>Geri bildirim ve sorgulama kayıtlarınıza ait kişisel bağlantılar.</li>
            </ul>
            <p className="mt-3 text-sm">Teklif taleplerinizdeki ad ve e-posta gibi kişisel alanlar temizlenir; talep kaydı anonimleştirilir.</p>
          </section>

          <section>
            <h2 className="flex items-center gap-2 text-[#0B1B33] font-bold text-base border-l-4 border-[#F97316] pl-3">
              <Database className="w-4 h-4 text-[#F97316]" /> Korunan Kayıtlar (Araç Geçmişi)
            </h2>
            <p className="mt-3 text-sm leading-relaxed">
              Otokünye bir araç geçmişi platformudur; <strong>araç geçmişi kayıtlarının kalıcı olarak korunması
              temel ilkemizdir</strong>. Hasar, kaza, ekspertiz, bakım, kaporta/boya, kilometre, muayene, servis ve
              araç belgelerine ait geçmiş kayıtlar:
            </p>
            <ul className="mt-2 list-disc pl-6 space-y-1.5 text-sm leading-relaxed">
              <li>Hesabınızı silseniz bile <strong>silinmez</strong>,</li>
              <li>Araç satılsa veya başka bir kullanıcıya devredilse bile <strong>korunur</strong>,</li>
              <li>Aracın tarihsel bütünlüğünü korumak amacıyla saklanmaya devam eder.</li>
            </ul>
            <p className="mt-3 text-sm leading-relaxed">
              Hesap silme işlemi yalnızca kişisel hesap bilgilerinizin silinmesini kapsar. Bu kayıtların sizinle olan
              kişisel bağlantısı (sahip kimliği ve e-posta bilgisi) <strong>KVKK yükümlülüklerine uygun şekilde
              kaldırılır veya anonimleştirilir</strong>; korunan kayıtlar hiçbir kişisel bilginizi içermez.
            </p>
          </section>

          <section>
            <h2 className="flex items-center gap-2 text-[#0B1B33] font-bold text-base border-l-4 border-[#F97316] pl-3">
              <Clock3 className="w-4 h-4 text-[#F97316]" /> Veri Saklama Süreleri
            </h2>
            <div className="mt-3 overflow-x-auto">
              <table className="w-full text-sm border-collapse">
                <thead>
                  <tr className="text-left text-[#0B1B33] text-xs">
                    <th className="py-2 pr-3 border-b border-slate-200">Veri Türü</th>
                    <th className="py-2 border-b border-slate-200">Saklama Süresi</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map(([t, s]) => (
                    <tr key={t} className="align-top">
                      <td className="py-2.5 pr-3 border-b border-slate-100 font-medium">{t}</td>
                      <td className="py-2.5 border-b border-slate-100 text-slate-600">{s}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>

          <section>
            <h2 className="flex items-center gap-2 text-[#0B1B33] font-bold text-base border-l-4 border-[#F97316] pl-3">
              <Mail className="w-4 h-4 text-[#F97316]" /> Giriş Yapamıyorsanız: Silme Talebi Formu
            </h2>
            <p className="mt-3 text-sm">Hesabınıza erişemiyorsanız, hesabınıza kayıtlı e-posta adresinizi yazarak silme talebi gönderebilirsiniz:</p>
            <form method="POST" action="/api/hesap-silme-talebi" className="mt-4 space-y-4">
              <div>
                <label htmlFor="email" className="block text-xs font-semibold text-[#0B1B33] mb-1.5">Hesabınıza kayıtlı e-posta adresi *</label>
                <input data-testid="hesap-silme-email-input" type="email" id="email" name="email" required placeholder="ornek@eposta.com"
                  className="w-full px-3.5 py-3 rounded-xl border-[1.5px] border-slate-200 text-sm focus:outline-none focus:border-[#F97316]" />
              </div>
              <div>
                <label htmlFor="note" className="block text-xs font-semibold text-[#0B1B33] mb-1.5">Not (isteğe bağlı)</label>
                <textarea id="note" name="note" rows={3} placeholder="Eklemek istediğiniz bir açıklama varsa yazabilirsiniz"
                  className="w-full px-3.5 py-3 rounded-xl border-[1.5px] border-slate-200 text-sm focus:outline-none focus:border-[#F97316]" />
              </div>
              <button data-testid="hesap-silme-form-submit" type="submit"
                className="w-full py-3.5 rounded-xl bg-[#F97316] hover:bg-[#EA580C] text-white text-sm font-bold transition-colors">
                Hesap Silme Talebi Gönder
              </button>
            </form>
            <div className="mt-4 bg-orange-50 border border-orange-200 rounded-xl p-3.5 text-xs leading-relaxed">
              Form ile gönderilen talepler önce yazdığınız e-posta adresi üzerinden doğrulanır; bu doğrulama, başka
              kişilerin sizin adınıza silme talebi göndermesini engeller. Doğrulama tamamlandıktan sonra hesabınız ve
              kişisel verileriniz kalıcı olarak silinir. Alternatif olarak kayıtlı e-posta
              adresinizden <a className="text-[#F97316] font-semibold" href="mailto:destek@otokunye.com?subject=Hesap%20Silme%20Talebi">destek@otokunye.com</a> adresine
              "Hesap Silme Talebi" konulu e-posta da gönderebilirsiniz.
            </div>
          </section>

          <div className="bg-blue-50 border border-blue-200 rounded-xl p-3.5 text-xs leading-relaxed text-slate-700">
            Bu sayfa Google Play Veri Güvenliği ve Apple App Store hesap silme gereklilikleri kapsamında hazırlanmıştır.
            Web, Android ve iOS uygulamalarımızın tamamında aynı hesap silme özelliği kullanılır.
          </div>

          <p className="text-xs text-slate-500">
            İlgili sayfa: <a className="text-[#F97316]" href="/gizlilik-politikasi.html">Otokünye Gizlilik Politikası</a>
          </p>
        </div>
        <p className="text-center text-slate-400 text-xs mt-8">© 2026 OTOKÜNYE — Her Aracın Bir Geçmişi Vardır</p>
      </div>
    </div>
  );
}
